import React, { useEffect, useState } from "react";
import { Button } from "antd";
import { toast } from "../../components/toasts/toastStore";

const MAX_BYTES = 5 * 1024 * 1024;

// Selector de imagen con vista previa. `value` es la URL de la foto ya guardada
// (opcional); `onChange` recibe el File elegido, o null si se quita.
export default function PacienteFotoPicker({ value, onChange, icon = "fa-user" }) {
  const [preview, setPreview] = useState(null);

  useEffect(() => () => { if (preview) URL.revokeObjectURL(preview); }, [preview]);

  const handlePick = (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.warning("El archivo debe ser una imagen");
      return;
    }
    if (file.size > MAX_BYTES) {
      toast.warning("La imagen no debe pesar mas de 5 MB");
      return;
    }
    setPreview(URL.createObjectURL(file));
    onChange?.(file);
  };

  const src = preview || value;

  return (
    <div className="paq-foto-picker">
      <div className="paq-foto-preview">
        {src ? <img src={src} alt="Foto" /> : <i className={`fa-solid ${icon}`} />}
      </div>
      <div className="paq-foto-actions">
        <label className="paq-foto-btn">
          <input type="file" accept="image/*" onChange={handlePick} hidden />
          <i className="fa-solid fa-camera" /> {src ? "Cambiar imagen" : "Subir imagen"}
        </label>
        {preview && (
          <Button type="text" onClick={() => { setPreview(null); onChange?.(null); }}>
            Quitar
          </Button>
        )}
        <span className="paq-foto-hint">JPG, PNG o WEBP. Maximo 5 MB.</span>
      </div>
    </div>
  );
}
